import { useEffect } from 'react'

import { GOOGLE_TAG_ID } from '@/consts'

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
    gtag?: CallableFunction
    __gtmInitialized?: boolean
  }
}

export function GoogleTagManager() {
  useEffect(() => {
    if (!GOOGLE_TAG_ID || window.__gtmInitialized) {
      return
    }

    window.__gtmInitialized = true
    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() {
      // Use arguments to mirror gtag signature expected by GTM consent mode.
      window.dataLayer.push(arguments as unknown as Record<string, unknown>)
    }

    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      wait_for_update: 500
    })

    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_ID}`
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_ID}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.cssText = 'display:none;visibility:hidden'
    noscript.appendChild(iframe)
    document.body.insertBefore(noscript, document.body.firstChild)
  }, [])

  return null
}
